import { SERVICES } from "@/data";
import { SectionHeading } from "./Buttons";
import * as Icons from "lucide-react";

export default function Services({ onOpenQuote }) {
  return (
    <section id="services" data-testid="services-section" className="relative bg-white py-20 md:py-28 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="What We Do"
          title={<>Everything your phone needs,<br /><span className="text-brand-red">in one local store.</span></>}
          sub="Repairs, unlocked phones, accessories, prepaid service, trade-ins, and tech help — handled by people who actually know phones."
          testid="services-heading"
        />

        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Wrench;
            const handleClick = (e) => {
              if (s.id === "sell") {
                e.preventDefault();
                onOpenQuote?.();
              }
            };
            return (
              <a
                key={s.id}
                href={s.href}
                onClick={handleClick}
                data-testid={`service-card-${s.id}`}
                className="card-soft card-soft-hover p-7 md:p-8 group relative overflow-hidden"
              >
                <div className="absolute -top-12 -right-12 w-40 h-40 rounded-full bg-green-50 opacity-0 group-hover:opacity-100 blur-3xl transition-all duration-500" />
                <div className="relative">
                  <div className="w-12 h-12 rounded-2xl bg-green-50 border border-green-100 grid place-items-center mb-6 group-hover:bg-brand-red group-hover:scale-110 transition-all">
                    <Icon className="w-6 h-6 text-brand-red group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="font-display text-2xl font-extrabold text-brand-navy tracking-tight">{s.title}</h3>
                  <p className="mt-3 text-sm md:text-base text-slate-600 leading-relaxed">{s.desc}</p>
                  <div className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-brand-red group-hover:gap-3 transition-all">
                    {s.cta}
                    <Icons.ArrowRight className="w-4 h-4" />
                  </div>
                </div>
                <span className="absolute top-6 right-6 text-xs font-mono font-bold text-slate-300">0{i + 1}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
